var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-3 mb-2 d-flex align-center",attrs:{"width":"100%","outlined":""},on:{"click":_vm.clickHandler}},[_c('v-main',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }